import { useCallback, useState } from 'react';

import { useBool } from './useBool';

export const useDialog = (defaultState = false) => {
    const dialog = useBool(defaultState);

    const [data, setData] = useState(null);

    const onSetData = useCallback((d) => {
        setData(d);
    }, []);

    const onResetData = useCallback(() => {
        setData(null);
    }, []);

    return {
        data,
        visible: dialog.value,
        onShow: dialog.onTrue,
        onClose: dialog.onFalse,
        onSetShow: dialog.onSet,
        onSetData,
        onResetData,
        onToggleShow: dialog.onToggle,
    };
};
